var _defs, _path, _g, _g2, _text, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogo = function SvgLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "den-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: "20.55in",
    height: "2.68in",
    viewBox: "0 0 1479.4 193.19",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: OpenSans-Bold, 'Open Sans';\n        font-size: 145.57px;\n        font-weight: 700;\n        letter-spacing: -.02em;\n      }\n\n      .cls-2 {\n        fill: #ffc400;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #ed0001;\n      }\n\n      .cls-4 {\n        fill: #ff9400;\n      }\n\n      .cls-5 {\n        fill: #ff6200;\n      }\n\n      .cls-6 {\n        fill: #b80c0a;\n      }\n\n      .current-color {\n        fill: currentColor;\n      }\n\n      .divider {\n        opacity: 0.6;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7 current-color",
    d: "m168.24,140.83v27.4H13.19V13.19h155.05v52.47c3.82-4.18,8.27-7.77,13.19-10.64V0H0v181.43h181.43v-29.95c-4.92-2.87-9.38-6.46-13.19-10.64h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "current-color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m253.55,18.71h-1.57c-8.26,0-14.95,6.69-14.95,14.95v25.69c0,2.11.66,4.17,1.86,5.91.74,1.07,1.43,2.17,2.08,3.3.13.24.3.45.5.63.13.12.26.25.38.37-1.51-1.45-3.12-2.8-4.82-4.04-7.72-5.62-17.22-8.95-27.5-8.95-25.81,0-46.74,20.93-46.74,46.74s20.93,46.74,46.74,46.74c10.28,0,19.78-3.32,27.5-8.95l1.48,4.77c.59,1.9,2.35,3.19,4.34,3.19h10.7c1.5,0,2.72-1.22,2.72-2.72V21.43c0-1.5-1.22-2.72-2.72-2.72h0Zm-44.02,112.11c-15.19,0-27.5-12.31-27.5-27.5s12.31-27.5,27.5-27.5,27.5,12.31,27.5,27.5-12.31,27.5-27.5,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m349.83,112.94c2.32,0,4.26-1.75,4.53-4.05.22-1.83.33-3.68.33-5.57,0-25.81-20.93-46.74-46.74-46.74s-46.74,20.85-46.74,46.74,20.93,46.74,46.74,46.74c17.98,0,33.59-10.16,41.41-25.04.77-1.47-.28-3.23-1.94-3.23h-15.89c-1.43,0-2.81.57-3.8,1.6-5,5.17-12.01,8.38-19.77,8.38-11.6,0-21.52-7.18-25.56-17.34-.28-.72.25-1.49,1.02-1.49h66.42,0Zm-41.88-36.17c10.83,0,20.2,6.26,24.68,15.36.36.72-.17,1.57-.98,1.57h-47.4c-.81,0-1.34-.85-.98-1.57,4.48-9.1,13.85-15.36,24.68-15.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m447.81,99.63c0-23.78-19.28-43.05-43.05-43.05-10.11,0-19.41,3.49-26.75,9.32.67-1.01,1.38-1.98,2.15-2.91.51-.61.79-1.38.79-2.17v-1.48c0-1.07-.87-1.93-1.93-1.93h-14.59c-1.5,0-2.72,1.22-2.72,2.72v39.51h0v46.72c0,1.5,1.22,2.72,2.72,2.72h13.8c1.5,0,2.72-1.22,2.72-2.72v-46.72c0-13.15,10.66-23.81,23.81-23.81s23.81,10.66,23.81,23.81h0v46.72c0,1.5,1.22,2.72,2.72,2.72h13.8c1.5,0,2.72-1.22,2.72-2.72v-46.72h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.3 45.19 100.79 50.33 106.49 22.78 68.3 45.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "84.74 66.62 100.79 50.33 68.3 45.19 84.74 66.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "100.79 50.33 113.64 104.28 84.74 66.62 100.79 50.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "100.79 50.33 113.64 104.28 119.82 70.13 100.79 50.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "84.74 66.62 90.1 94.96 47.81 104.89 84.74 66.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "90.1 94.96 128.24 123.3 84.74 66.62 90.1 94.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "99.59 122.6 90.1 94.96 111.97 111.21 128.24 123.3 99.59 122.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "128.24 123.3 118.42 145.74 78.13 159.36 128.24 123.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "78.13 159.36 47.81 104.89 90.1 94.96 78.13 159.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "90.1 94.96 78.13 159.36 99.59 122.6 90.1 94.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "78.13 159.36 99.59 122.6 128.24 123.3 78.13 159.36"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1 current-color",
    transform: "translate(556.26 149.08)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frontier Safe"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7 divider current-color",
    x: 501.81,
    y: 22.78,
    width: 7.52,
    height: 136.58,
    rx: 2.16,
    ry: 2.16
  })));
};
export default SvgLogo;